import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

/**
 * Tooltip Controller
 * 
 * Manages Bootstrap tooltips for elements.
 * Automatically initializes and disposes of tooltip instances.
 * 
 * Features:
 * - Initializes Bootstrap tooltips on connect
 * - Properly disposes of tooltips on disconnect
 * - Prevents memory leaks from tooltip instances
 * 
 * Usage: Add data-controller="tooltip" to elements that need Bootstrap tooltips
 */
export default class extends Controller {
  connect() {
    this.tooltip = new bootstrap.Tooltip(this.element)
  }

  disconnect() {
    if (this.tooltip) {
      this.tooltip.dispose()
    }
  }
} 